import { SaneImage } from '@components/sanity';
import { GetStarted, SmallQuote } from '@components/solutions';
import {
  AuthYourWay,
  PrebuiltComponents,
  RemixContexts
} from '@components/solutions/remix';
import { URLS } from '@lib';
import { singlePageProps } from '@lib/singlePageProps';

export default function RemixPage(props: any) {
  const { image, text } = props;

  return (
    <>
      <section className="mt-10 mb-32">
        <div className="relative pt-6">
          <div className="px-4 mx-auto max-w-7xl sm:px-6">
            <div className="text-center">
              <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-6xl xl:text-7xl">
                <span className="block">The easy solution to</span>
                <span className="block text-clerk-blue">
                  Remix authentication
                </span>
              </h1>
              <p className="max-w-md mx-auto mt-3 text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
                Add users to your Remix application in minutes
              </p>
            </div>
          </div>
        </div>
        <GetStarted doc={URLS.remixDocs} />
      </section>

      <section className="mt-12" id="quote">
        <SmallQuote
          quote={text.quoteBody}
          name={text.quoteName}
          title={text.quoteTitle}
          image={image.quote}
        />
      </section>

      <div className="mt-10">
        <div className="relative px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-8">
            <div className="md:order-last lg:mx-0 lg:col-span-1">
              <SaneImage
                wrapClassName="image-wrap rounded-xl overflow-hidden max-w-xs md:max-w-none"
                src={image.remixglowing}
              />
            </div>
            <div className="mt-4 md:mt-0 lg:col-span-2 lg:text-left">
              <h1 className="mt-1 text-3xl font-extrabold tracking-tight text-gray-900 lg:text-4xl">
                Why Clerk for Remix authentication?
              </h1>
              <p className="mt-3 text-base text-gray-500 sm:mt-4 lg:text-lg xl:text-xl">
                Remix and Clerk are both built for speed, with native support
                for SSR and edge computing environments. Plus, Clerk uses JWTs
                so Remix authentication is stateless and takes under one
                millisecond.
              </p>
              <p className="mt-3 text-base text-gray-500 sm:mt-4 lg:text-lg xl:text-xl">
                Beyond our similar philosophy, the greatest benefits of Clerk
                are our flexible authentication strategies, the beautiful
                components we provide, and our seamless integration experience.
                Learn more below!
              </p>
            </div>
          </div>
        </div>
      </div>

      <AuthYourWay />

      <PrebuiltComponents {...props} />

      <RemixContexts />
    </>
  );
}

export async function getStaticProps({ preview = false }) {
  const slug = '/solutions/remix-authentication';
  return singlePageProps({ preview, slug });
}
